import { useTranslation } from 'react-i18next';

// Language selector for header usage
export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const languages = ['en', 'de', 'fr', 'es', 'it', 'hu', 'nl'];
  return (
    <div className="flex items-center gap-2">
      <span className="text-evat-gold font-inter text-sm">{t('language')}</span>
      <select
        value={i18n.language}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        className="bg-black border border-evat-neon text-evat-neon px-2 py-1 rounded"
      >
        {languages.map((lng) => (
          <option key={lng} value={lng}>{lng.toUpperCase()}</option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSwitcher;



















